module.exports = __webpack_public_path__ + "static/img/pop-guide.45028ee.png";


//////////////////
// WEBPACK FOOTER
// ./static/fundingnew/profile/pop-guide.png
// module id = vLmf
// module chunks = 1